import {
  useV4GetRetailersLocationsQuery,
  type V4GetRetailersLocationsQuery,
  type V4GetRetailersLocationsQueryVariables,
} from '../../__codegen__/api'

export interface V4GetRetailersLocationsResult {
  retailerLocations: V4GetRetailersLocationsQuery['instacart_customers_partners_v1_PartnersService_GetRetailerLocations']['retailerLocations']
  loading: boolean
  error: Error
}

export const useV4GetRetailersLocations = (params: V4GetRetailersLocationsQueryVariables) => {
  const { data, previousData, loading, error } = useV4GetRetailersLocationsQuery({
    variables: params,
    skip: !params.ids?.length && !params.name,
  })

  return {
    retailerLocations: (data || previousData)
      ?.instacart_customers_partners_v1_PartnersService_GetRetailerLocations?.retailerLocations,
    loading,
    error,
  }
}
